import { OrderState } from '@store/order/OrderState';
import { CustomerOrderDef } from '@api/types/CustomerOrderDef';
import { CatCustomerOrderDef } from '@api/types/CatCustomerOrderDef';
import { CollarTypeEnum } from '@pages/order/collar-type/CollarTypeEnum';
import { Purchase } from '@features/gtm/types/Purchase';
import { generateGuid } from '@components/utils';
import { PricingModel } from '@api/types/PricingModel';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';
import { getLanguageCurrency } from '@translations/functions';



export const convertToCustomerOrderDef = (state: OrderState): CustomerOrderDef | null => {
	if (!state.sizeA) return null;
	if (!state.sizeB) return null;
	if (!state.sizeC) return null;
	if (!state.race) return null;
	if (!state.age) return null;
	if (!state.surgerySegments || state.surgerySegments.length === 0) return null;
	if (!state.surgeryDate) return null;
	if (!state.name) return null;
	if (!state.email) return null;
	if (!state.invoiceStreet) return null;
	if (!state.invoiceCity) return null;
	if (!state.invoicePostalCode) return null;
	if (!state.selectedType) return null;
	if (!state.collarType) return null;
	if (!state.payment) return null;
	if (!state.delivery) return null;
	if (!state.country) return null;

	return {
		sizeA: state.sizeA,
		sizeB: state.sizeB,
		sizeC: state.sizeC,
		race: state.race,
		age: state.age,
		behaviourDesc: state.behaviourDesc,
		issueDesc: state.issueDesc,
		surgeryDate: state.surgeryDate,
		name: state.name,
		email: state.email,
		phoneNumber: state.phoneNumber,
	
		street: state.street,
		city: state.city,
		postalCode: state.postalCode,
		invoiceStreet: state.invoiceStreet,
		invoiceCity: state.invoiceCity,
		invoicePostalCode: state.invoicePostalCode,
		
		selectedType: state.selectedType,
		message: state.message,
		paymentType: state.payment.id,
		delivery: state.delivery.id,
		dispatchPoint: state.dispatchPoint ? state.dispatchPoint : undefined,
		discountCode: state.discountCode,
		base64: state.imageBase64 ? state.imageBase64 : undefined,
		selectedSections: state.surgerySegments,
		hasStrap: state.collarType === CollarTypeEnum.withBuckle ? true : false,
		country: state.country,
		sourceRef: state.sourceRef ? state.sourceRef : undefined,
	}
}


export const convertToOrderPurchase = (state: OrderState, price: PricingModel, country: AppLanguageCode): Purchase => {
	
	let shipping = state.delivery && state.payment ? state.delivery.price + state.payment.price : 0;
	let tax = price.priceWithVat - price.priceNoVat;
	let priceWithoutVat = price.priceNoVat - shipping;

	return {
		transaction_id: generateGuid(),
		shipping: state.delivery && state.payment ? state.delivery.price + state.payment.price : null,
		currency: getLanguageCurrency(country),
		value: priceWithoutVat,
		coupon: state.discountCode ? state.discountCode : null,
		tax: tax,
		items: [
			{
				item_id: 'limec_pes',
				item_name: 'limec_pes',
				item_category: 'limec_pes',
				item_variant: state.collarType ? state.collarType : null,
				price: priceWithoutVat,
			}
		],
	}
}


export const convertToCatCustomerOrderDef = (state: OrderState): CatCustomerOrderDef | null => {
	if (!state.sizeB) return null;
	if (!state.sizeC) return null;
	if (!state.race) return null;
	if (!state.age) return null;
	if (!state.issueDesc) return null;
	if (!state.surgeryDate) return null;
	if (!state.name) return null;
	if (!state.email) return null;
	if (!state.invoiceStreet) return null;
	if (!state.invoiceCity) return null;
	if (!state.invoicePostalCode) return null;
	if (!state.selectedType) return null;
	if (!state.payment) return null;
	if (!state.delivery) return null;
	if (!state.country) return null;

	return {
		sizeA: state.sizeB,
		sizeB: state.sizeC,
		race: state.race,
		age: state.age,
		behaviourDesc: state.behaviourDesc,
		issueDesc: state.issueDesc,
		surgeryDate: state.surgeryDate,
		name: state.name,
		email: state.email,
		phoneNumber: state.phoneNumber,
	
		street: state.street,
		city: state.city,
		postalCode: state.postalCode,
		invoiceStreet: state.invoiceStreet,
		invoiceCity: state.invoiceCity,
		invoicePostalCode: state.invoicePostalCode,
		
		selectedType: state.selectedType,
		message: state.message,
		paymentType: state.payment.id,
		delivery: state.delivery.id,
		dispatchPoint: state.dispatchPoint ? state.dispatchPoint : undefined,
		discountCode: state.discountCode,
		base64: state.imageBase64 ? state.imageBase64 : undefined,
		country: state.country,
		sourceRef: state.sourceRef ? state.sourceRef : undefined,
	}
}



export const convertToCatOrderPurchase = (state: OrderState, price: PricingModel, country: AppLanguageCode): Purchase => {

	let shipping = state.delivery && state.payment ? state.delivery.price + state.payment.price : 0;
	let tax = price.priceWithVat - price.priceNoVat;
	let priceWithoutVat = price.priceNoVat - shipping;

	return {
		transaction_id: generateGuid(),
		shipping: state.delivery && state.payment ? state.delivery.price + state.payment.price : null,
		currency: getLanguageCurrency(country),
		value: priceWithoutVat,
		coupon: state.discountCode ? state.discountCode : null,
		tax: tax,
		items: [
			{
				item_id: 'limec_kocka',
				item_name: 'limec_kocka',
				item_category: 'limec_kocka',
				price: priceWithoutVat,
			}
		],
	}
}